import { useSearch } from '@tanstack/react-router';

export function useIsInframe() {
	const { iframe } = useSearch({ from: '__root__' });
	return iframe;
}
